import { useEffect } from "react";
import "./App.css";
import ServiceCard from "./components/ServiceCard";
import Chatbot from "./components/Chatbot"; // 👈 aggiungi questo
function App() {
  // useEffect(() => {
  //   const ctaButton = document.getElementById("cta-button");
  //   const moduliSection = document.getElementById("moduli");
  //   let visible = false;

  //   ctaButton.addEventListener("click", () => {
  //     visible = !visible;
  //     if (visible) {
  //       moduliSection.style.display = "block";
  //       ctaButton.textContent = "Nascondi i moduli";
  //       moduliSection.scrollIntoView({ behavior: "smooth" });
  //     } else {
  //       moduliSection.style.display = "none";
  //       ctaButton.textContent = "Scopri la suite";
  //     }
  //   });
  // }, []);

  var articles = [
    {
      title: "SemaFix",
      subtitle: "Ottimizzazione cicli semaforici",
      description:
        "Progetta e ottimizza i cicli semaforici considerando conflitti, capacità di saturazione per manovra e flussi in ingresso, inclusi i pedonali. Genera piani semaforici completi e diagrammi di fase ottimizzati, sia per impianti nuovi che per l’efficientamento di quelli esistenti.",
      tags: ["Piani semaforici", "Diagrammi fase", "Conflitti"],
      imageSrc: "assets/semafix.png",
      moduleName: "SemaFix",
    },
    {
      title: "SignalFix",
      subtitle: "Censimento & gestione segnaletica",
      description:
        "Rileva e geolocalizza in tempo reale la segnaletica verticale attraverso una tecnologia mobile avanzata. I dati sono importati direttamente nel modulo, dove vengono strutturati in un database geo-referenziato, aggiornabile ed editabile.",
      tags: ["Mobile mapping", "AI", "Db geo‑referenziato"],
      imageSrc: "assets/signalfix.png",
      moduleName: "SignalFix",
    },
    {
      title: "SyncFix",
      subtitle: "Onda verde & sincronizzazione",
      description:
        "Calcola l’offset ottimale a partire dalla velocità di marcia, gestisce l’onda verde tra impianti su mappa e ne simula il funzionamento tramite animazione e diagrammi di fase. Consente di caricare, modificare e georeferenziare impianti esistenti o nuovi.",
      tags: ["Offset", "Simulazione", "Mappa animata"],
      imageSrc: "assets/syncfix2.png",
      moduleName: "SyncFix",
    },
    {
      title: "SimFix",
      subtitle: "Analisi scenari simulati",
      description:
        "Visualizza e confronta i risultati delle microsimulazioni attraverso indicatori chiave come accodamenti, livelli di servizio e metriche arco per arco. Evidenzia il miglior scenario progettuale sulla base delle performance complessive di rete.",
      tags: ["KPI", "Microsimulazione", "What if scenario"],
      imageSrc: "assets/simfix.png",
      moduleName: "SimFix",
    },
    {
      title: "MysteryX",
      subtitle: "Benchmark Mystery Client",
      description:
        "Valuta e confronta i risultati di indagini 'mystery client' sugli operatori TPL, aggregando punteggi secondo un modello gerarchico che copre diverse categorie di servizio. Offre visualizzazioni comparative per identificare i punti di forza e le aree critiche tra i partecipanti.",
      tags: ["TPL", "Val  utazioni", "Report"],
      imageSrc: "assets/mysteryx.png",
      moduleName: "MysteryX",
    },
    {
      title: "Be‑Twin | Raise",
      subtitle: "Digital Twin & metriche di contesto",
      description:
        "Visualizza i risultati del progetto BETWIN basato su un caso studio reale (Varco Passo Nuovo – Genova). Integra geometrie 3D navigabili, analisi ambientali, valutazione delle esternalità e anomaly detection in tempo reale, per una gestione avanzata di contesto.",
      tags: ["3D", "Mobility", "Realtime"],
      imageSrc: "assets/betwin.png",
      moduleName: "Be-Twin | Raise",
    },
  ];

  var onClickRegister = () => {
    window.location.href = "";
  };

  return (
    <div className="App">
      <div class="colored-rect"></div>
      <div class="overlay">
        <header>
          <img
            src={require("./assets/TraffixLogo.png")}
            alt="Logo Traffix"
            class="logo"
          />
          <p class="hero-subtitle">
            La piattaforma modulare per gestire, analizzare e ottimizzare la mobilità urbana.
          </p>
          <p class="hero-hint">Accedi al tuo account o crea un profilo gratuito per iniziare.</p>
          <div class="cta-group">
            <a
              class="cta cta-primary"
              href="https://demo.traffixcloud.com/auth"
              target="_blank"
              rel="noopener noreferrer"
            >
              Accedi
            </a>
            <a
              class="cta cta-secondary"
              href="https://demo.traffixcloud.com/auth?register=true"
              target="_blank"
              rel="noopener noreferrer"
            >
              Crea un account
            </a>
          </div>
        </header>

        <footer>
          <img src={require("./assets/logo-societa4.png")} alt="Logo Società" />
          <div class="white-bar"></div>
          <p>
            © {new Date().getFullYear()} Exis Mobility. Tutti i diritti
            riservati.
          </p>
        </footer>

        {/* <section id="moduli" class="moduli-section">
          <div class="moduli-content">
            <div class="moduli-grid" role="list">
              {articles.map((article, index) => (
                <ServiceCard
                  key={index}
                  title={article.title}
                  subtitle={article.subtitle}
                  description={article.description}
                  tags={article.tags}
                  imageSrc={article.imageSrc}
                  moduleName={article.moduleName}
                />
              ))}
            </div>
          </div>
        </section> */}
        {/* <Chatbot /> */}
      </div>
    </div>
  );
}

export default App;
